// Фінансова звітність мікропідприємства, форма № 1-мс (баланс) і № 2-мс (звіт про фінансові результати) — S0111007
// (НП(С)БО 25, додаток 2). Структура — з шаблону бланка кабінету ДПС (doc/report/template-one/S0111007), порядок XML — як у
// поданому й прийнятому файлі. Одиниця — тис. грн з одним десятковим знаком.
// Баланс: графа 3 — на початок звітного року, 4 — на кінець звітного періоду. Фінрезультати: 3 — звітний період, 4 — попередній.
export const FIN_CDOC = "S0111007";
export const FIN_NAME = "Фінансова звітність мікропідприємства (Форма № 1-мс, № 2-мс)";

// [код, текст, тип: h — заголовок, t — підсумок (рахується), n — від'ємний (у дужках), формула для підсумку]
export const BALANCE = [
  ["", "Актив", "h"],
  ["", "I. Необоротні активи", "h"],
  ["1010", "Основні засоби: залишкова вартість", "t", (v) => v("1011") - v("1012")],
  ["1011", "первісна вартість"],
  ["1012", "знос", "n"],
  ["1090", "Інші необоротні активи"],
  ["1095", "Усього за розділом I", "t", (v) => v("1010") + v("1090")],
  ["", "II. Оборотні активи", "h"],
  ["1100", "Запаси"],
  ["1155", "Поточна дебіторська заборгованість"],
  ["1165", "Гроші та їх еквіваленти"],
  ["1190", "Інші оборотні активи"],
  ["1195", "Усього за розділом II", "t", (v) => v("1100") + v("1155") + v("1165") + v("1190")],
  ["1300", "Баланс", "t", (v) => v("1095") + v("1195")],
  ["", "Пасив", "h"],
  ["", "I. Власний капітал", "h"],
  ["1400", "Капітал"],
  ["1420", "Нерозподілений прибуток (непокритий збиток)"],
  ["1425", "Неоплачений капітал", "n"],
  ["1495", "Усього за розділом I", "t", (v) => v("1400") + v("1420") - v("1425")],
  ["1595", "II. Довгострокові зобов'язання, цільове фінансування та забезпечення"],
  ["", "III. Поточні зобов'язання", "h"],
  ["1600", "Короткострокові кредити банків"],
  ["", "Поточна кредиторська заборгованість:", "h"],
  ["1615", "за товари, роботи, послуги"],
  ["1620", "за розрахунками з бюджетом"],
  ["1625", "за розрахунками зі страхування"],
  ["1630", "за розрахунками з оплати праці"],
  ["1690", "Інші поточні зобов'язання"],
  ["1695", "Усього за розділом III", "t", (v) => v("1600") + v("1615") + v("1620") + v("1625") + v("1630") + v("1690")],
  ["1900", "Баланс", "t", (v) => v("1495") + v("1595") + v("1695")],
];
export const RESULTS = [
  ["2000", "Чистий дохід від реалізації продукції (товарів, робіт, послуг)"],
  ["2160", "Інші доходи"],
  ["2280", "Разом доходи (2000 + 2160)", "t", (v) => v("2000") + v("2160")],
  ["2050", "Собівартість реалізованої продукції (товарів, робіт, послуг)", "n"],
  ["2165", "Інші витрати", "n"],
  ["2285", "Разом витрати (2050 + 2165)", "t", (v) => v("2050") + v("2165")],
  ["2290", "Фінансовий результат до оподаткування (2280 − 2285)", "t", (v) => v("2280") - v("2285")],
  ["2300", "Податок на прибуток", "n"],
  ["2310", "Витрати (доходи), які зменшують (збільшують) фінансовий результат після оподаткування"],
  ["2350", "Чистий прибуток (збиток) (2290 − 2300 − (+) 2310)", "t", (v) => v("2290") - v("2300") - v("2310")],
];
const tagOf = (code, col) => `${Number(code) >= 2000 ? "B" : "A"}${code}_${col}`;
export const ROW_CODES = [...BALANCE, ...RESULTS].filter((r) => r[0]).map((r) => r[0]);
const r1 = (x) => Math.round(x * 10) / 10;

// Значення поданого звіту: { "1010_3": 38.3, … }
export function readFin(xml) {
  const out = {};
  for (const m of String(xml || "").matchAll(/<([AB])(\d{4})_([34])>([^<]*)<\/\1\2_\3>/g)) out[`${m[2]}_${m[3]}`] = Number(String(m[4]).replace(",", ".")) || 0;
  return out;
}
const tag = (xml, t) => (String(xml || "").match(new RegExp(`<${t}>([^<]*)</${t}>`)) || [])[1] ?? null;

// Розрахунок звіту за рік з чернетки:
//   prev — значення поданого звіту за попередній рік (його графа 4 балансу → наша графа 3; його графа 3 фінрезультатів → наша графа 4);
//   doc.values — введені користувачем { "1011_4": …, "2000_3": … } (тис. грн); підсумки рахуємо самі
export function computeFin({ year, prev = null, doc = {}, hints = {} }) {
  const needs = [], warnings = [];
  const entered = doc.values || {};
  const val = {};
  // Графа 3 балансу — на початок року = на кінець попереднього; графа 4 фінрезультатів — попередній рік
  for (const [code] of BALANCE.filter((r) => r[0])) val[`${code}_3`] = entered[`${code}_3`] ?? prev?.[`${code}_4`] ?? 0;
  for (const [code] of RESULTS) val[`${code}_4`] = entered[`${code}_4`] ?? prev?.[`${code}_3`] ?? 0;
  for (const [code] of BALANCE.filter((r) => r[0])) val[`${code}_4`] = Number(entered[`${code}_4`] ?? 0);
  for (const [code] of RESULTS) val[`${code}_3`] = Number(entered[`${code}_3`] ?? 0);
  // Підсумки — по графах, у порядку рядків (формули посилаються на попередні)
  for (const col of ["3", "4"]) {
    const v = (c) => Number(val[`${c}_${col}`] || 0);
    for (const [code, , kind, f] of [...BALANCE, ...RESULTS]) if (kind === "t" && f) val[`${code}_${col}`] = r1(f(v));
  }
  for (const k of Object.keys(val)) val[k] = r1(Number(val[k]) || 0);
  // Контроль: актив = пасив на обидві дати; нерозподілений прибуток змінився на чистий прибуток року
  for (const col of ["3", "4"]) if (Math.abs(val[`1300_${col}`] - val[`1900_${col}`]) >= 0.05)
    needs.push({ key: `bal-${col}`, title: `Баланс не сходиться ${col === "3" ? "на початок року" : "на кінець року"}: актив (1300) ${val[`1300_${col}`]} ≠ пасив (1900) ${val[`1900_${col}`]} тис. грн` });
  const d1420 = r1(val["1420_4"] - val["1420_3"]);
  if (Math.abs(d1420 - val["2350_3"]) >= 0.05) warnings.push({ key: "1420", title: `Нерозподілений прибуток змінився на ${d1420}, а чистий прибуток року — ${val["2350_3"]} тис. грн; різниця можлива, якщо нараховували дивіденди або виправляли помилки минулих років` });
  if (!prev) warnings.push({ key: "noprev", title: "Звітності за попередній рік у «Перегляді звітності» немає — графи «на початок року» і «попередній період» заповніть самі" });
  if (!val["1300_4"]) needs.push({ key: "empty", title: "Баланс на кінець року не заповнено" });
  for (const code of ROW_CODES) for (const col of ["3", "4"]) if (val[`${code}_${col}`] < 0 && !["1420", "2290", "2350", "2310"].includes(code)) needs.push({ key: `neg-${code}-${col}`, title: `Рядок ${code}: від'ємне значення (у формі такі суми — у дужках, вносяться додатними)` });
  // Підказки, що залежать від введеного (наприклад, + податок на прибуток року)
  const h = Object.fromEntries(Object.entries(hints).map(([k, x]) => [k, x.plus ? { ...x, value: r1(x.value + (val[x.plus] || 0)) } : x]));
  // Податок на прибуток — орієнтовно 18 % прибутку до оподаткування (точно — за декларацією з податку на прибуток)
  if (val["2290_3"] > 0 && !h["2300_3"]) h["2300_3"] = { value: r1(val["2290_3"] * 0.18), note: "18 % фінансового результату до оподаткування — орієнтовно; точно — з декларації з податку на прибуток" };
  h["1400_4"] ??= { value: val["1400_3"], note: "як на початок року, якщо капітал не змінювали" };
  h["1420_4"] ??= { value: r1(val["1420_3"] + val["2350_3"]), note: "на початок року + чистий прибуток року (рядок 2350), якщо дивідендів не нараховували" };
  return { ok: needs.length === 0, year, values: val, needs, warnings, hints: h };
}

// Строк подання річної фінансової звітності — 60 днів після кінця року (разом із декларацією з податку на прибуток); вихідний — наступний робочий
export function finDeadline(year) {
  const t = new Date(Date.UTC(Number(year) + 1, 0, 1, 12)); t.setUTCDate(t.getUTCDate() + 59);
  while ([0, 6].includes(t.getUTCDay())) t.setUTCDate(t.getUTCDate() + 1);
  return t.toISOString().slice(0, 10);
}

const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const fmt = (x) => r1(x).toFixed(1);
const pad = (n) => String(n).padStart(2, "0");
// XML звіту: шапка й реквізити — з поданого минулого року файла (той самий порядок полів), значення — наші;
// порожні й нульові рядки не пишемо (як у прийнятому файлі)
// asNew — «звітний новий» (C_DOC_STAN 2, C_DOC_TYPE — порядковий номер виправленого документа за період): подається замість
// уже поданої звітності до закінчення строку подання
export function buildFinXml({ prevXml, res, cnt = 1, fillDate = new Date(), staff = null, asNew = null }) {
  const year = Number(res.year);
  let head = String(prevXml).slice(0, String(prevXml).indexOf("<DECLARBODY>"))
    .replace(/<PERIOD_YEAR>[^<]*<\/PERIOD_YEAR>/, `<PERIOD_YEAR>${year}</PERIOD_YEAR>`).replace(/<PERIOD_MONTH>[^<]*<\/PERIOD_MONTH>/, "<PERIOD_MONTH>12</PERIOD_MONTH>")
    .replace(/<PERIOD_TYPE>[^<]*<\/PERIOD_TYPE>/, "<PERIOD_TYPE>5</PERIOD_TYPE>").replace(/<C_DOC_CNT>[^<]*<\/C_DOC_CNT>/, `<C_DOC_CNT>${cnt}</C_DOC_CNT>`)
    .replace(/<C_DOC_VER>[^<]*<\/C_DOC_VER>/, "<C_DOC_VER>07</C_DOC_VER>").replace(/S0111\d\d\.XSD/i, "S0111007.XSD")
    .replace(/<D_FILL>[^<]*<\/D_FILL>/, `<D_FILL>${pad(fillDate.getDate())}${pad(fillDate.getMonth() + 1)}${fillDate.getFullYear()}</D_FILL>`)
    .replace(/<SOFTWARE>[^<]*<\/SOFTWARE>/, "<SOFTWARE>eCabinet</SOFTWARE>")
    .replace(/<C_DOC_TYPE>[^<]*<\/C_DOC_TYPE>/, `<C_DOC_TYPE>${asNew ? asNew.type : 0}</C_DOC_TYPE>`);
  // C_DOC_STAN (1 — звітний, 2 — звітний новий) — після C_STI_ORIG, перед LINKED_DOCS / D_FILL, якщо в шаблоні його немає
  const stan = `<C_DOC_STAN>${asNew ? 2 : 1}</C_DOC_STAN>`;
  head = /<C_DOC_STAN>/.test(head) ? head.replace(/<C_DOC_STAN>[^<]*<\/C_DOC_STAN>/, stan) : head.replace(/(<LINKED_DOCS|<D_FILL>)/, `${stan}$1`);
  const body = String(prevXml).slice(String(prevXml).indexOf("<DECLARBODY>") + "<DECLARBODY>".length, String(prevXml).indexOf("</DECLARBODY>"));
  const items = [...body.matchAll(/<([A-Za-z0-9_]+)>([^<]*)<\/\1>/g)].map((m) => [m[1], m[2]]);
  const isVal = (t) => /^[AB]\d{4}_[34]$/.test(t);
  const first = items.findIndex(([t]) => isVal(t)), last = items.length - 1 - [...items].reverse().findIndex(([t]) => isVal(t));
  const before = items.slice(0, first < 0 ? items.length : first).filter(([t]) => !isVal(t)), after = first < 0 ? [] : items.slice(last + 1).filter(([t]) => !isVal(t));
  const set = { REP_PERNM: `Рік ${year}`, MY_DATE: `3112${year}`, N13: String(year + 1), N14: "1", LASTDAY: "1", ...(staff != null ? { S_CH: String(staff) } : {}) };
  const line = ([t, v]) => `        <${t}>${set[t] != null ? esc(set[t]) : v}</${t}>`;
  const vals = ROW_CODES.flatMap((code) => ["3", "4"].map((col) => [tagOf(code, col), res.values[`${code}_${col}`]])).filter(([, v]) => Number(v) !== 0).map(([t, v]) => `        <${t}>${fmt(v)}</${t}>`);
  const missing = Object.keys(set).filter((t) => !before.some(([x]) => x === t) && !after.some(([x]) => x === t)).map((t) => `        <${t}>${esc(set[t])}</${t}>`);
  return `${head}<DECLARBODY>\n${[...before.map(line), ...missing, ...vals, ...after.map(line)].join("\n")}\n    </DECLARBODY>\n</DECLAR>\n`;
}

export const finHead = (xml) => ({ tin: tag(xml, "TIN"), name: tag(xml, "FIRM_NAME"), sti: tag(xml, "C_STI_ORIG"), reg: tag(xml, "C_REG"), raj: tag(xml, "C_RAJ"),
  ruk: tag(xml, "FIRM_RUK"), buh: tag(xml, "FIRM_BUH"), staff: tag(xml, "S_CH"), kved: tag(xml, "FIRM_KVED"), year: Number(tag(xml, "PERIOD_YEAR")) || null });
